export const stackWall = `\
-- stack bond
-- no stagger, joints align vertically

S
`
